module.exports = __webpack_public_path__ + "static/avatar-8ab1a2fcb63fc4fa382da2316976e098.jpg";